import AutoScroll from "embla-carousel-auto-scroll";
import { useRef } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import schesirLogo from "@/assets/schesir-logo.png";
import prolifeLogo from "@/assets/prolife-logo.png";
import disugualLogo from "@/assets/disugual-logo.png";
import vincentLogo from "@/assets/vincent-logo.jpg";
import libraLogo from "@/assets/libra-logo.png";
import naturalTrainerLogo from "@/assets/natural-trainer-logo.png";
import hillsLogo from "@/assets/hills-logo.png";
import advanceLogo from "@/assets/advance-logo.png";
import stuzzyLogo from "@/assets/stuzzy-logo.jpeg";
import togetherLogo from "@/assets/together-logo.jpg";

const Brands = () => {
  const brands = [
    { id: 1, name: "Schesir", logo: schesirLogo },
    { id: 2, name: "Prolife", logo: prolifeLogo },
    { id: 3, name: "Disugual", logo: disugualLogo },
    { id: 4, name: "Vincent", logo: vincentLogo },
    { id: 5, name: "Libra", logo: libraLogo },
    { id: 6, name: "Natural Trainer", logo: naturalTrainerLogo },
    { id: 7, name: "Hill's", logo: hillsLogo },
    { id: 8, name: "Advance", logo: advanceLogo },
    { id: 9, name: "Stuzzy", logo: stuzzyLogo },
    { id: 10, name: "Together", logo: togetherLogo },
  ];

  const autoScrollPlugin = useRef(
    AutoScroll({
      speed: 1,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      startDelay: 0,
      playOnInit: true,
    })
  );

  return (
    <section className="py-12 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="mb-4 text-primary uppercase text-2xl md:text-4xl text-center" style={{ fontFamily: 'Verdana, sans-serif' }}>I Nostri Brand</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto" style={{ fontFamily: 'Verdana, sans-serif' }}>
            Lavoriamo con i migliori marchi del settore per garantirti prodotti
            di qualità superiore
          </p>
        </div>

        <div className="animate-fade-in-up" style={{ animationDelay: "0.1s" }}>
          <Carousel
            opts={{
              loop: true,
              dragFree: true,
            }}
            plugins={[autoScrollPlugin.current]}
            className="w-full"
          >
            <CarouselContent className="-ml-4">
              {brands.map((brand, index) => (
                <CarouselItem
                  key={index}
                  className="pl-4 basis-1/2 md:basis-1/3 lg:basis-1/4 xl:basis-1/5"
                >
                  <div className="bg-card rounded-xl p-6 shadow-[var(--shadow-medium)] border border-border hover:shadow-[var(--shadow-large)] transition-all duration-300 h-32 flex items-center justify-center group">
                    <img
                      src={brand.logo}
                      alt={brand.name}
                      className="max-w-full max-h-full object-contain opacity-90 group-hover:opacity-100 transition-opacity duration-300"
                      draggable={false}
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Brands;
